<body>
  <!--<app-nav-menu></app-nav-menu>-->
  <div class="container-fluid" style=" padding-right: 0px; padding-left: 0px;">
    <router-outlet></router-outlet>
    <!--<app-footer></app-footer>-->
  </div>
  <app-footer></app-footer>
</body>




